import { useReviews } from "contexts/DataContext";
import { useWindowSize } from "hooks/useWindowSize";
import type { TrustpilotTestimonialProps } from "./TrustpilotTestimonial.d";
import { TrustpilotTestimonialDesktop } from "./TrustpilotTestimonialDesktop";
import { TrustpilotTestimonialMobile } from "./TrustpilotTestimonialMobile";

export const TrustpilotTestimonial = ({
  srcDesktop,
  srcMobile,
  height,
  alt,
  cardDesktopPosition = "left",
}: TrustpilotTestimonialProps) => {
  const windowSize = useWindowSize();
  const reviews = useReviews();

  if (!windowSize) return null;

  const { isDesktop } = windowSize;

  const imageProps = {
    alt,
    height,
    width: "100%",
    loading: "lazy" as const,
    src: (isDesktop ? srcDesktop : srcMobile) || srcDesktop,
  };

  return isDesktop ? (
    <TrustpilotTestimonialDesktop imageProps={imageProps} review={reviews[0]} cardPosition={cardDesktopPosition} />
  ) : (
    <TrustpilotTestimonialMobile imageProps={imageProps} review={reviews[0]} />
  );
};
